// extracted by mini-css-extract-plugin
export default {"container":"Login_container__2pcnf","innerBox":"Login_innerBox__qMHx7","footer":"Login_footer__FdTO-","error":"Login_error__6iUM9"};